
import { Clock } from "lucide-react";
import { CompanyRequest } from "@/lib/types";
import EmptyPendingRequestsState from "./EmptyPendingRequestsState";
import PendingRequestActions from "./PendingRequestActions";

interface PendingRequestsTableProps {
  pendingRequests: CompanyRequest[];
  onApprove: (request: CompanyRequest) => void;
  onReject: (request: CompanyRequest) => void;
}

const PendingRequestsTable = ({ pendingRequests, onApprove, onReject }: PendingRequestsTableProps) => {
  return (
    <div className="bg-white rounded-lg shadow-sm border p-6">
      <h2 className="text-xl font-medium mb-4">Pending Requests</h2>
      
      {pendingRequests.length > 0 ? (
        <div className="overflow-x-auto">
          <table className="w-full border-collapse">
            <thead>
              <tr className="border-b">
                <th className="text-left py-3 px-4 font-medium">Company Name</th>
                <th className="text-left py-3 px-4 font-medium">Location</th>
                <th className="text-left py-3 px-4 font-medium">Contact Email</th>
                <th className="text-left py-3 px-4 font-medium">Date Requested</th>
                <th className="text-right py-3 px-4 font-medium">Actions</th>
              </tr>
            </thead>
            <tbody>
              {pendingRequests.map((request) => (
                <tr key={request.id} className="border-b hover:bg-gray-50">
                  <td className="py-3 px-4">
                    <div className="flex items-center gap-2">
                      <Clock className="w-4 h-4 text-amber-500" />
                      <span>{request.companyName}</span>
                    </div>
                  </td>
                  <td className="py-3 px-4">
                    {request.location}
                  </td>
                  <td className="py-3 px-4">
                    {request.contactEmail}
                  </td>
                  <td className="py-3 px-4">
                    {new Date(request.createdAt).toLocaleDateString()}
                  </td>
                  <td className="py-3 px-4 text-right">
                    <PendingRequestActions 
                      request={request} 
                      onApprove={onApprove} 
                      onReject={onReject}
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <EmptyPendingRequestsState />
      )}
    </div>
  );
};

export default PendingRequestsTable;
